var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"payment-type-options"}},[_c('button',{staticClass:"button-secondary",on:{"click":_vm.createTransaction}},[_c('div',{staticClass:"sprite google-pay-light",attrs:{"id":"googlepay-mark"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }